var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentitySpecial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10882_20665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 9.31368 2.68629 12 6 12C9.31368 12 12 9.31368 12 6C12 2.68629 9.31368 0 6 0Z",
    fill: "#52CC8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56235 2.3999C3.33702 2.3999 3.15434 2.58257 3.15434 2.80791C3.15434 3.03325 3.33702 3.21592 3.56235 3.21592H8.43634C8.66168 3.21592 8.84435 3.03325 8.84435 2.80791C8.84435 2.58257 8.66168 2.3999 8.43634 2.3999H3.56235ZM1.8501 4.39834C1.8501 4.173 2.03277 3.99033 2.25811 3.99033C4.75277 3.99033 7.24743 3.99033 9.74209 3.99033C9.96743 3.99033 10.1501 4.173 10.1501 4.39834C10.1501 4.62368 9.96743 4.80635 9.74209 4.80635H9.16982V8.43752H9.74209C9.96743 8.43752 10.1501 8.62019 10.1501 8.84553C10.1501 9.07087 9.96743 9.25354 9.74209 9.25354C7.24743 9.25354 4.75278 9.25354 2.25811 9.25354C2.03277 9.25354 1.8501 9.07087 1.8501 8.84553C1.8501 8.62019 2.03277 8.43752 2.25811 8.43752H2.82602V4.80635H2.25811C2.03277 4.80635 1.8501 4.62368 1.8501 4.39834ZM7.32687 8.43752H8.3538V5.31981C8.3538 5.03623 8.12391 4.80635 7.84034 4.80635C7.55676 4.80635 7.32687 5.03623 7.32687 5.31981V8.43752ZM5.99792 4.80635C6.28121 4.80635 6.51085 5.036 6.51085 5.31928V8.43752H5.48499V5.31928C5.48499 5.036 5.71464 4.80635 5.99792 4.80635ZM3.64204 5.31981C3.64204 5.03623 3.87193 4.80635 4.15551 4.80635C4.43909 4.80635 4.66897 5.03623 4.66897 5.31981V8.43752H3.64204V5.31981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10882_20665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentitySpecial);
export default __webpack_public_path__ + "static/media/identity-special.3572efea07c714003e200e205f8bbb21.svg";
export { ForwardRef as ReactComponent };